module.exports = __webpack_public_path__ + "static/img/dev2.668ff81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/dev2.jpg
// module id = X3uB
// module chunks = 1